import router from '../../router'
import auth from './auth/auth'
import dbRefs from './dbRefs'
import axios from 'axios'
import geo from 'geo-hash'
import common from './common/common'
//var XMLHttpRequest = require("xmlhttprequest").XMLHttpRequest;
//var xhr = new XMLHttpRequest();
import querystring from 'querystring'

const state = {
  isAPICalling: false,
  btnLoader: false,
  snackbar_alert_msg: '',
  appName: '',
  loader: false,
  forceRouteLoader: true,
  showSnack: false,
  _isFirstVisit: false,
  showLoader: false,
  finalUserLocation: '',
  sheet: false,
  opencw: false,
  share_photoId: '',
  share_caption: ''
}

const getters = {
  btnLoader: state => state.btnLoader,
  snackbar_alert_msg: state => state.snackbar_alert_msg,
  appName: state => state.appName,
  loader: state => state.loader,
  forceRouteLoader: state => state.forceRouteLoader,
  _isFirstVisit: state => state._isFirstVisit,
  finalUserLocation: state => state.finalUserLocation,
  sheet: state => state.sheet,
  opencw: state => state.opencw
}

const mutations = {
  //
  UPDATE_IS_API_CALLING(state2, payload) {
    let val = payload.val
    state.isAPICalling = val
  },
  getLocationFinal(state2) {
    // console.log('localStorage.getItem(isLocationEnabled)', localStorage.getItem('isLocationEnabled'))
    if(localStorage.getItem('isLocationEnabled') != null) {
      // console.log('CALLING GET LOCATION')
      if(navigator.geolocation) {
        common.state.fetchLocLoader = true
        navigator.geolocation.getCurrentPosition(
          (success)=> {
            common.state.fetchLocLoader = false
            // console.log('CALLING GET LOCATION 2')
            localStorage.setItem('isLocationEnabled', 'y') // allow
            state.finalUserLocation = geo.encode(success.coords.latitude,success.coords.longitude)
            // console.log('state.finalUserLocation', state.finalUserLocation)
          },
          (error) => {
            common.state.fetchLocLoader = false
            // console.log('JSON.parse(localStorage.getItem(isLocationEnabled)',localStorage.getItem('isLocationEnabled'))
            if(localStorage.getItem('isLocationEnabled') != null) {
              common.state.showOverlay = true
            }



            // let cnt = JSON.parse(localStorage.getItem('locationBlockCnt'))
            /*  if(cnt === null) {
                cnt = 1
              }
              else {
                common.state.showOverlay = true
                cnt += 1
              } */
            localStorage.removeItem('isLocationEnabled')
            // localStorage.setItem('locationBlockCnt', JSON.stringify(cnt))
            // block or close popup
          })
        window.thisOfApp.$modal.hide('location-modal')
      }
    }
  },

  checkIfLocAllowed(state2) {
    // console.log('calling checkIfLocAllowed')
    let isLocAllowed = localStorage.getItem('isLocationEnabled')
    if(isLocAllowed == 'y') {
      mutations.getLocationFinal(state)
    }
  },
  //
  //goTo
  goTo(state2,path){
    router.push(path)
  },
  //
  //snackbar //alert
  snackbar_alert(state2, payload) {
    //
    state.snackbar_alert_msg = payload.msg
    //
    // var x = document.getElementById("snackbar")
    // x.className = "show"
    // setTimeout(function(){
      // x.className = x.className.replace("show", "")
    // }, 3000)
    state.showSnack = true
  },
  //
  //forceRoute
  forceRoute(state2, payload){
    console.log(`forceRoute`, payload)
    //
    //state.forceRouteLoader = true
    //
    if(payload.routeName == 'User Details' ||
      payload.routeName.indexOf('Upload Image') != -1 ){
      if(!auth.state.isLoggedIn){
        //go back
        mutations.goTo(state, '/')
      }
    }
    //
    setTimeout(()=>{
      state.forceRouteLoader = false
    },100)
  },
}

const actions = {
  //
  isEmptyField(state2, payload){ //accepts arr of object( *fieldValue* to validate & *fieldName* (to notify err)), check if strings are empty
    // console.log("[isEmptyPayload]", payload)
    //
    return new Promise((res)=>{
      //
      let isEmpty = false
      let fieldName
      //
      for(let i in payload.checkVarsIfEmpty_arr){
        // console.log("isEmptyField => ", payload.checkVarsIfEmpty_arr[i])
        if(payload.checkVarsIfEmpty_arr[i].fieldValue.length == 0){ //use regex instead
          fieldName = payload.checkVarsIfEmpty_arr[i].fieldName
          isEmpty = true
          break
        }
      }
      //
      if(isEmpty){ //prints message if empty
        mutations.snackbar_alert(state, {
          msg: 'Empty Field: ' + fieldName
        })
      }
      //
      res(isEmpty) // returns true if empty, or returns false
    })
  },
  //
  //save doc in db
  mergeDocToDb(state2, payload) {
    // console.log("[saveDocToDb] => ", payload)
    //
    let dbPath = payload.dbPath
    let obj = payload.obj
    //
    return dbRefs
      .state
      .firestore
      .doc(dbPath)
      .set(obj)
  },
  //
  //get data from => doc
  getDataFromDoc(state2, payload){
    // console.log("[get data form doc]", payload)
    //
    let dbPath = payload.dbPath
    //
    return dbRefs
      .state
      .firestore
      .doc(dbPath)
      .get()
    //
  },
  //
  //axios get request
  axiosGetReq(state2, payload) { //payload => url, obj
    // console.log("[axios get request]" , payload)
    //
    return axios.get(payload.url, {
      params: payload.obj
    })
  },
  //
  //axios post request
  axiosPostReq(state2, payload){
    // console.log("[axios post request]" , payload)
    //
    // console.log("[axiosPostUrl]", payload.url)
    // console.log("[axiosGetUrl]", payload.obj)
    //
    return axios.post(
      payload.url,
      payload.obj
    )
  },
  //
  //get past tags selected by the users
  getTags_uploadImage(state2, payload){
    let qStr = payload.qStr
    let qTag = payload.qTag
    //
    // console.log("[qStr]", qStr)
    // console.log("[qTag]", qTag)
    //
    return actions
      .axiosGetReq(state, {
        url: 'https://us-central1-travel-app-admin.cloudfunctions.net/getTagSuggestion_uploadImage',
        obj: {
          qStr,
          qTag,
          isCron: 'n'
        }
      })
  },
  //
  //save image in - storage
  saveImgInStorage(state2, payload){
    //
    // console.log("[uploadImageStorage]", payload)
    //
    let pKey =   payload.pUrl.slice(payload.pUrl.lastIndexOf('/')+1);
    let pBlob = payload.pBlob
    //
    //console.log("2 => ",state.storage)
    //
    //console.log(payload)
    //console.log(pKey)
    //console.log(payload.pBlob)
    //
    return new Promise((res, err)=>{
      //
      let uploadTask = dbRefs.state.storage.ref(pKey).put(pBlob);
      //
      uploadTask.on('state_changed', function(snapshot) {
        //
        //
      }, function(error){
        //
        //console.log(error)
        err(error)
        //
      },function() {
        //
        //console.log(uploadTask.snapshot.downloadURL)
        res({
          pKey,
          downloadUrl: uploadTask.snapshot.downloadURL
        })
        //
      })
    })
  },
  //
  //upload image - DOM
  uploadImg(state2, payload){ //DOM
    //
    let pUrl = URL.createObjectURL(payload.event.target.files[0]); //
    let pKey = pUrl.slice(pUrl.lastIndexOf('/') + 1); //
    //
    let pBlob = payload.event.target.files[0];
    //
    state.pObj = {};
    //
    //if(!payload.mulImg){ // if not multiple image clear obj
    //state.pObj = {}
    //}
    //
    state.pObj = {
      pBlob,
      pUrl
    }
    //
    //console.log(state.pObj)
    //
    //window.tag.$forceUpdate() //no need not showing pic
  },
  //
  arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
      for(var j=i+1; j<a.length; ++j) {
        if(a[i] === a[j])
          a.splice(j--, 1);
      }
    }
    return a;
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/gen.js